import { render, staticRenderFns } from "./TopContent.vue?vue&type=template&id=120d1e5b&scoped=true&"
import script from "./TopContent.vue?vue&type=script&lang=js&"
export * from "./TopContent.vue?vue&type=script&lang=js&"
import style0 from "./TopContent.vue?vue&type=style&index=0&id=120d1e5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120d1e5b",
  null
  
)

export default component.exports